import {Box, CloseButton, createStyles, Flex, Group, Stack, Text, Title} from '@mantine/core';
import React from 'react';

const useStyles = createStyles((theme) => ({
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: theme.white,
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
  },
  scrollableContent: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    backgroundColor: theme.colors.gray[0],
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
    backgroundColor: theme.colors.gray[0],
    borderTop: `1px solid ${theme.colors.gray[2]}`,
  },
}));

interface FullScreenFlowProps {
  children: React.ReactNode;
}

export function FullScreenFlow({children}: FullScreenFlowProps): JSX.Element {
  return (
    <Flex direction="column" h="100%" w="100%" bg="white">
      {children}
    </Flex>
  );
}

interface FullScreenFlowHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  onClose?: () => void;
}

export function FullScreenFlowHeader({title, subtitle, onClose}: FullScreenFlowHeaderProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Group position="apart" noWrap={true} p="lg" className={classes.stickyHeader}>
      <Stack spacing={2}>
        <Title order={2}>{title}</Title>
        {subtitle != null && (
          <Text size="sm" c="dimmed">
            {subtitle}
          </Text>
        )}
      </Stack>
      {onClose != null && <CloseButton size="lg" onClick={onClose} aria-label="Close" />}
    </Group>
  );
}

interface FullScreenFlowContentProps {
  children: React.ReactNode;
}

export function FullScreenFlowContent({children}: FullScreenFlowContentProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Box p="lg" className={classes.scrollableContent}>
      {children}
    </Box>
  );
}

interface FullScreenFlowFooterProps {
  children: React.ReactNode;
}

export function FullScreenFlowFooter({children}: FullScreenFlowFooterProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Box p="lg" pr="48px" className={classes.stickyFooter}>
      {children}
    </Box>
  );
}
